'use client'

import { ThemeProvider as MUIThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { ReactNode, useMemo } from 'react'
import themeOptions from './themes'

export default function ThemeProvider({ children, direction }: { children: ReactNode; direction: 'rtl' | 'ltr' }) {
    // Create the theme using the options from the environment-specific theme
    const theme = useMemo(() => createTheme(themeOptions, { direction }), [])
    return (
        <MUIThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </MUIThemeProvider>
    )
}
